var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"analytic-report analytic-report-grid"},[_c('AnalyticEmployeeArticle'),_c('AnalyticSidebar',{attrs:{"show-paid":false,"show-categories":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }